<template>
  <main class="main main--register main--register-dentist">
    <div class="gradient-bg" />

    <ui-auth
      title="Create Your Dentist Account"
      slug="registerDentist"
      copy="Create your account to join the growing team of experts demonstrating quality in dentistry.  Your account will allow you to submit your patient’s radiographs for review and track their progress.  You can also request to become an independent reviewer of other’s work."
      :terms="terms"
      submit="Create Account"
    >
      <div slot="top-link">
        <p class="small">Already have an account? <router-link :to="{ name: 'login' }">Log in</router-link> <br>Not a dentist? <router-link :to="{ name: 'register-patient' }">Register as a Patient</router-link></p>
      </div>
      <div slot="before-submit">
        <p class="mt0 mb0 small">By signing up you agree to the VeriTooth</p>
        <p class="mt0 small"><router-link :to="{ name: 'terms' }" target="_blank">Terms &amp; Conditions</router-link> and <router-link :to="{ name: 'privacy' }" target="_blank">Privacy Policy</router-link></p>
      </div>
    </ui-auth>
  </main>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex';

// Models
import meta from 'models/meta';

// Services
import { createMeta } from 'services/meta';

// Ui
import UiAuth from 'ui/Auth';

// Export
export default {
  name: `view-register-dentist`,

  // Meta data
  metaInfo: {
    title: meta.register.title,
    meta: createMeta(meta.register.meta),
  },

  // Components
  components: {
    UiAuth,
  },

  // Data
  data() {
    return {
      terms: [
        `By signing up you agree to the VeriTooth `,
        `<a href="/terms" target="_blank">T&Cs</a> and <a href="/policy" target="_blank">Privacy Policy</a>`,
      ],
    };
  },

  computed: {
    ...mapGetters(`auth`,[
      `showTour`,
    ]),
  },

  // Methods
  methods: {
    ...mapActions(`forms`, [
      `updateValue`,
    ]),
    ...mapActions(`auth`, [
      `activateTour`,
    ]),
  },

  // Lifecycle
  mounted() {
    // this.activateTour(true);
    if (this.$route.name === `register-dentist`) {
      this.activateTour(`dentist`);
    } else if (this.$route.name === `register-reviewer`) {
      this.activateTour(`reviewer`);
    }
    this.$nextTick(() => {
      this.updateValue({
        form: `registerDentist`,
        field: `tour_taken`,
        value: true,
      });
    });
    const email = sessionStorage.getItem(`dentist_email`) || this.$route.query.email || false;

    if (email) {
      this.$nextTick(() => {
        this.updateValue({
          form: `registerDentist`,
          field: `email`,
          value: email,
        });
      });

      sessionStorage.removeItem(`dentist_email`);
    }
  },
};
</script>



// WEBPACK FOOTER //
// RegisterDentist.vue?c95c7a22